module.exports = __webpack_public_path__ + "img/Revibe-logo.4af32dd8.png";